// Generated by ReScript, PLEASE EDIT WITH CARE


var storageKey = "gdc.theme";

var defaultTheme = "dark";

function themeToString(theme) {
  if (theme === "light") {
    return "light";
  } else {
    return "dark";
  }
}

function resolveTheme() {
  var match = localStorage.getItem(storageKey);
  if (!(match == null)) {
    switch (match) {
      case "dark" :
          return "dark";
      case "light" :
          return "light";
      default:
        
    }
  }
  var mq = matchMedia("(prefers-color-scheme: dark)");
  if (!(mq == null) && !mq.matches) {
    return "light";
  } else {
    return "dark";
  }
}

function applyThemeClasses(theme) {
  var html = document.documentElement;
  var body = document.body;
  var themeStr = themeToString(theme);
  html.setAttribute("data-theme", themeStr);
  if (theme === "light") {
    html.classList.remove("dark");
    if (!(body == null)) {
      body.classList.remove("dark");
      return ;
    } else {
      return ;
    }
  } else {
    html.classList.add("dark");
    if (!(body == null)) {
      body.classList.add("dark");
      return ;
    } else {
      return ;
    }
  }
}

function getTheme() {
  return themeToString(resolveTheme());
}

function setTheme(theme) {
  var t = theme === "light" ? "light" : "dark";
  localStorage.setItem(storageKey, themeToString(t));
  applyThemeClasses(t);
}

function nextTheme(current) {
  if (current === "dark") {
    return "light";
  } else {
    return "dark";
  }
}

function installGlobals() {
  window.getTheme = getTheme;
  window.setTheme = setTheme;
}

function applyInitialHtmlTheme() {
  var theme = resolveTheme();
  var html = document.documentElement;
  html.setAttribute("data-theme", themeToString(theme));
  if (theme === "dark") {
    html.classList.add("dark");
    return ;
  }
  
}

installGlobals();

applyInitialHtmlTheme();

function resolveThemePure(stored, prefersDark) {
  if (stored !== undefined) {
    switch (stored) {
      case "dark" :
          return "dark";
      case "light" :
          return "light";
      default:
        
    }
  }
  if (prefersDark !== undefined && !prefersDark) {
    return "light";
  } else {
    return "dark";
  }
}

function resolveThemeJs(stored, prefersDark) {
  return themeToString(resolveThemePure(stored, prefersDark));
}

function nextThemeJs(current) {
  return themeToString(nextTheme(current));
}

var themeStorageKey = storageKey;

var defaultThemeValue = defaultTheme;

export {
  storageKey ,
  defaultTheme ,
  themeToString ,
  resolveTheme ,
  applyThemeClasses ,
  getTheme ,
  setTheme ,
  nextTheme ,
  installGlobals ,
  applyInitialHtmlTheme ,
  resolveThemePure ,
  resolveThemeJs ,
  nextThemeJs ,
  themeStorageKey ,
  defaultThemeValue ,
}
/*  Not a pure module */
